/** Top-level fields merged into every golden-funnel dataLayer push. */

import { getVendorAnonIds } from './vendor-anon-ids';

type RuntimeEnvWindow = Window & { __ENV__?: Record<string, string | undefined> };

function readRuntimeEnv(): Record<string, string | undefined> | undefined {
  if (typeof window === 'undefined') return undefined;
  return (window as RuntimeEnvWindow).__ENV__;
}

export function getDataLayerContext(): Record<string, string> {
  if (typeof window === 'undefined') return {};

  const ctx: Record<string, string> = {};
  const runtimeEnv = readRuntimeEnv();

  const storeId =
    (typeof runtimeEnv?.VITE_STORE_ID === 'string' && runtimeEnv.VITE_STORE_ID) ||
    (typeof runtimeEnv?.VITE_FUNNELS_STORE_ID === 'string' &&
      runtimeEnv.VITE_FUNNELS_STORE_ID) ||
    '';

  if (storeId) ctx.store_id = storeId;
  if (typeof window.location?.href === 'string') ctx.page_location = window.location.href;
  if (typeof document?.title === 'string') ctx.page_title = document.title;

  const vendorAnonIds = getVendorAnonIds();
  if (vendorAnonIds.tfp_anon_id) ctx.tfp_anon_id = vendorAnonIds.tfp_anon_id;
  if (vendorAnonIds.segment_anon_id) ctx.segment_anon_id = vendorAnonIds.segment_anon_id;

  return ctx;
}
